export const isLocalEnvironment = document.location.host === 'localhost:3000';

export const isTestEnvironmentSCBInside = document.location.host === 'service-sk-test.sovcombank.group';

export const isProdEnvironmentSCB = document.location.host === 'service.sovcomlife.ru';

export const isProdEnvironmentSCBInside = document.location.host === 'lk2.uvp-sk-web-app1.sovcombank.group';

export const isProdEnvironment = isProdEnvironmentSCB || isProdEnvironmentSCBInside;

export const getCaptchaSiteKey = () => {
    if (isProdEnvironmentSCB) {
        return 'ysc1_vWcG8b5AD0Ri4wIyZluJCa9GH5AK3dzNczmain56b5e42b83';
    }
    return '';
};

export const sanitizeText = (value) => (typeof value === 'string' ? value.replace(/<[^>]*>/g, '') : value);
